import qs from 'qs';
import BaseHttp from '@/plugins/baseHttp';

const BASE_PATH = '/subscription-plans';

/**
 * Lists plans. Query params are forwarded whole — the screen uses
 * `has_trial` to split paid from free plans.
 *
 * @param {Object} params query params
 */
const get = (params = {},) => {
  return BaseHttp.get(`${BASE_PATH}?${qs.stringify(params,)}`,);
};

/* Plan detail, including the `audit_logs` that feed the side modal timeline. */
const getById = (id,) => BaseHttp.get(`${BASE_PATH}/${id}`,);

const enable = (id,) => BaseHttp.post(`${BASE_PATH}/${id}/enable`,);

const disable = (id,) => BaseHttp.post(`${BASE_PATH}/${id}/disable`,);

export default {
  get,
  getById,
  enable,
  disable,
};
